module.exports = __webpack_public_path__ + "static/media/about10.7fef128a.jpg";